<template>
  <div class="conditions">
    <div class="conditions__directions">
      Selecciona la condición
    </div>
    <div class="conditions__group">
      <div class="conditions__group__label">
        Jugando de:
      </div>
      <CheckBoxButtons :items="conditions.arrayLocality" />
    </div>
    <div class="h-separator" />
    <div class="conditions__directions">
      Selecciona lapsos de tiempo
    </div>
    <div class="conditions__group">
      <div class="conditions__group__label">
        1er Tiempo:
      </div>
      <CheckBoxButtons :items="conditions.arrayTimeSections" :slice="{ start: 0, end: 3 }" />
    </div>
    <div class="conditions__group">
      <div class="conditions__group__label">
        2do Tiempo:
      </div>
      <CheckBoxButtons :items="conditions.arrayTimeSections" :slice="{ start: 3, end: 6 }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPlayerConditions',
  components: {
    CheckBoxButtons: () => import('@/components/Sections/MediaPlayer-v3/CheckBoxButtons'),
  },
  props: {
    propName: {
      type: Number,
      default: 0,
    },
    conditions: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.conditions {
  font-size: 1rem;
  width: 100%;
  padding: 12px 9px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__directions {
    font-family: Avenir-Demi-Medium, sans-serif;
    font-size: 0.6975em;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.22px;
    text-align: right;
    color: #5d6872;
  }

  &__group {
    width: 100%;
    margin-top: 0.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &__label {
      margin: 0.5em 1em;
      font-family: Roboto-Medium, sans-serif;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: -0.14px;
      text-align: center;
      color: #132839;
    }
  }
}

.h-separator {
  width: 100%;
  height: 1px;
  border-bottom: dashed 1px #cbd0d4;
  margin: 1.2em 0;
}
</style>
